// extracted by mini-css-extract-plugin
export default {"modifyBtn":"AdminMobileCateList_modifyBtn__7hoiq","deleteBtn":"AdminMobileCateList_deleteBtn__CCuoD"};